import './types/hero';
import './types/clients-slider';
import './types/tiles-widgets';
import './types/column-sections';
import './types/chessboard';
import './types/services-slider-section';
import './types/latest-insights';
import './types/demo-section';
import './types/more-news';
import './types/quote';
import './types/article-content-post';
import './types/webinar-content-post';
import './types/podcast-content-post';
import './types/product-hero';
import './types/banners';
import './types/stepper-slider';
import './types/horizontal-slider';
import './types/demo-form';
import './types/vertical-image-slider';
import './types/faq';
import './types/offerings-section';
import './types/top-with-image';
import './types/carbon-section';
import './types/products-items';
import './types/quote-wrapper';
import './types/course-intro';
import './types/course-details';
import './types/hero-bottom-image';
import './types/team-section';
import './types/breadcrumbs';
import './types/address-card';
import './types/widgets-section';
import './types/awards-slider';
import './types/product-tiles';
import './types/faq-inner';
import './types/checklist';
import './types/posts-list-with-filters';
import './types/insights-listing';
import './types/event-page';
import './types/event-inner-details';
import './types/event-inner-partners';
import './types/columns-section-inner';
import './types/button';
import './types/people';
import './types/column-sections-images';
import './types/storylane';
import './types/blockId';
import './types/horizontal-extended-slider';
import './types/banner';
import './types/custom-list-block';
import './types/extend-core-list';
import './types/floating-form';
import './types/metrics-section';
import './types/image-content-section';
// import './types/page-standard';

function removePTagsFromLinks() {
  const links = document.querySelectorAll(
    '.wp-block-freeform.block-library-rich-text__tinymce a'
  );

  if (links.length > 0) {
    links.forEach((link) => {
      if (link.parentNode.nodeName === 'P') {
        const parent = link.parentNode;
        parent.parentNode.insertBefore(link, parent);
        parent.remove();
      }
    });
    return true;
  }
  return false;
}

document.addEventListener('DOMContentLoaded', function () {
  //AOS.init();

  const interval = setInterval(() => {
    if (removePTagsFromLinks()) {
      clearInterval(interval);
    }
  }, 1000); // Checks every 1 second
});
